export default "__VITE_ASSET__qFKE1$hD__"